var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"group"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.group.name))]),_vm._v(" "),_c('span',{staticClass:"memberCount"},[_vm._v(_vm._s(_vm.group.memberCount)+"人")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad0d6dca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Group.vue
// module id = null
// module chunks = 